'use client';

import { useLingui } from '@lingui/react';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { Box, Button, Stack } from '@mui/material';
import { Application, translate, useRouter } from '@prismo-io/router';
import type { LanguageCodeT } from '@prismo-io/schemas';
import Link from 'next/link';
import { type ComponentProps, type FC, useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

type Props = {
  stepIdx: number;
};

export const FooterBtn: FC<Props> = (props) => {
  const { stepIdx } = props;

  const {
    formState: { isValid, isSubmitSuccessful },
  } = useFormContext();

  const { i18n } = useLingui();

  const previous = useMemo((): Pick<
    ComponentProps<typeof Button>,
    'disabled' | 'href'
  > => {
    const previousIdx = stepIdx - 1;

    const previousLink = translate({
      app: Application.ONBOARDING,
      path: '/parcours/etapes/:step',
      params: {
        step: previousIdx,
      },
      locale: i18n.locale as LanguageCodeT,
    });

    return {
      disabled: previousIdx <= 0,
      href: previousLink,
    };
  }, [stepIdx, i18n.locale]);

  const next = useMemo((): Pick<
    ComponentProps<typeof Button>,
    'disabled' | 'href'
  > => {
    return {
      disabled: !isValid || isSubmitSuccessful,
    };
  }, [isValid, isSubmitSuccessful]);

  const router = useRouter();

  useEffect(() => {
    if (isSubmitSuccessful) {
      router.refresh();
      setTimeout(() => {
        const nextIdx = stepIdx + 1;
        console.log('RRR', nextIdx);

        router.push({
          app: Application.ONBOARDING,
          path: '/parcours/etapes/:step',
          params: {
            step: nextIdx,
          },
          locale: i18n.locale as LanguageCodeT,
        });
      }, 500);
    }
  }, [isSubmitSuccessful, router, stepIdx, i18n.locale]);

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      marginTop={2}
    >
      {stepIdx === 1 ? (
        <Box component="div" />
      ) : (
        <Button
          variant="text"
          color="gray"
          startIcon={<ArrowBack />}
          component={Link}
          {...previous}
        >
          Précedent
        </Button>
      )}
      <Button
        variant="contained"
        color="gradient"
        formNoValidate
        endIcon={<ArrowForward />}
        {...next}
        type="submit"
      >
        Suivant
      </Button>
    </Stack>
  );
};
